import { Injectable } from '@angular/core';
import { CartActions } from '@cart/data-access';
import { EnvironmentService } from '@core/feature';
import { Actions, createEffect, EffectNotification, ofType } from '@ngrx/effects';
import { EMPTY, iif, Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { PromotionAlertService } from '../services/promotion-alert.service';

@Injectable()
export class CartPromotionsEffects {
  showPromotions$: Observable<void> = createEffect(
    () =>
      this.actions$.pipe(
        ofType(CartActions.LOAD_CART_SUCCESS),
        map((action: CartActions.LoadCartSuccess) => action.payload),
        tap(({ cart }) => {
          this.promotionAlertService.processData(cart.code, cart.appliedOrderPromotions);
        }),
        map(() => undefined),
      ),
    { dispatch: false },
  );

  constructor(
    private actions$: Actions,
    private promotionAlertService: PromotionAlertService,
    private environmentService: EnvironmentService,
  ) {}

  ngrxOnRunEffects(resolvedEffects$: Observable<EffectNotification>): Observable<EffectNotification> {
    return iif(() => this.environmentService.isPlatformBrowser, resolvedEffects$, EMPTY);
  }
}
